module.exports = __webpack_public_path__ + "img/ic_12_plus_white.390bd753.svg";